/** @jsx jsx */
import { jsx, ThemeUIStyleObject } from "theme-ui";
import React from "react";
import { AspectRatio } from "@shared-components/AspectRatio/AspectRatio";
import { Box } from "@shared-components/Box/Box";
import { Text } from "@shared-components/Text/Text";
import { DownloadModule } from "src/carlsberg-headless/types/modules/Download";
import { ButtonLink } from "@shared-components/Button/Button";
import { Container } from "@shared-components/Container/Container";
import {
  downloadAspectStyles,
  downloadButtonStyle,
  downloadImgStyle,
  downloadStyle,
  downloadTextBoxStyle,
  downloadHeadingTextStyle,
  downloadDescriptionTextStyle,
} from "./styles";
import { Heading } from "@shared-components/Heading/Heading";
import { UmbracoBackgroundImage } from "@shared-components/Image/UmbracoBackgroundImage/UmbracoBackgroundImage";

export interface DownloadProps extends DownloadModule {
  sx: ThemeUIStyleObject;
  bottleCollection?: boolean;
}

const Download: React.FC<DownloadProps> = ({
  cbKey,
  image,
  imagesAltText,
  mediaUpload,
  downloadLinkText,
  title,
  description,
  sx,
  bottleCollection = false,
}) => {
  if (image) {
    image.altText = imagesAltText;
  }

  console.log(mediaUpload);

  return (
    <Container key={cbKey} sx={{ ...downloadStyle, ...sx }}>
      <AspectRatio
        ratio={bottleCollection ? ["1:1"] : ["1:1", "16:9", "16:9"]}
        sx={downloadAspectStyles}
      >
        {image && (
          <UmbracoBackgroundImage
            image={image}
            width={[300, 600]}
            sx={downloadImgStyle}
          />
        )}
      </AspectRatio>
      <Box sx={downloadTextBoxStyle}>
        <Box>
          {title && (
            <Heading as="h3" sx={downloadHeadingTextStyle}>
              {title}
            </Heading>
          )}
          {description && (
            <Text as="p" sx={downloadDescriptionTextStyle}>
              {description}
            </Text>
          )}
        </Box>
        {(mediaUpload?.fullUrl || mediaUpload?.url) && (
          <ButtonLink
            to={
              mediaUpload.fullUrl ??
              "https://home-of-carlsberg.euwest01.umbraco.io" + mediaUpload.url
            }
            target="_blank"
            download={
              mediaUpload.fullUrl ??
              "https://home-of-carlsberg.euwest01.umbraco.io" + mediaUpload.url
            }
            variant="green"
            sx={
              !description && !image
                ? { textDecoration: "none", margin: "auto" }
                : downloadButtonStyle
            }
          >
            {downloadLinkText}
          </ButtonLink>
        )}
      </Box>
    </Container>
  );
};

export { Download };
